module.exports = __webpack_public_path__ + "img/StoryRover-success.520411f6.png";